<div class="container">
  <div class="nav-Dashbord1 d-flex justify-content-between">
    <p class="textDashbord">{{'navigation.text' | translate}}
    </p>
    <!--<div class="row pull-left">
      <a style="color:blue" (click)="changeLanguag('fr')" class="col-sm-3"> FR </a>
      <a style="color:rebeccapurple" (click)="changeLanguag('en')" class="col-sm-3">En</a>
    </div>-->

    <div class="d-flex-nav position-relative">
    <a class="navbar-brand d-flex nav-justified">
      <div ngbDropdown class="d-inline-block elementDrop">
        <div class="block-btnModife">
          <button class="btn btnModife no-shadow" id="company"
                  ngbDropdownToggle>{{currentSelection?.code.toUpperCase()}}</button>
        </div>
        <div class="cp" ngbDropdownMenu aria-labelledby="dropdownBasic1" id="menu-langue">
          <div class="cp-dropdown">
            <div class="cp-dropdown__select">
              <p class="cp-dropdown__select-option cursor" *ngFor="let option of options"
                 (click)="changeLanguag(option)">{{option?.name}}</p>
            </div>
          </div>
        </div>
      </div>
    </a>
    </div>
  </div>

</div>
